export default "/images/next.svg?ce6b6d66ef129dbc968c0e0cc3f51665";